module.exports = __webpack_public_path__ + "img/1417.929f1f86.gif";